import { json } from '@remix-run/node';

import { B2BLandingPage } from '@modules/b2b/B2BLandingPage';
import { profsConfig } from '@modules/b2b/config/profs.config';
import {
    createMetaDescription,
    createMetaTitle,
    createOGTags,
    mergeMeta,
} from '~/modules/seo';
import { B2B_CANONICAL_ORIGIN } from '~/utils/business-subdomain';

/**
 * Professionals landing page served at
 * `business.archiproamerica.com/professionals` via the edge rewrite to
 * `/b2b/professionals`. Renders `B2BLandingPage` with `profsConfig` — the
 * "Become a Pro" version of the brands page (different hero photo + copy,
 * shared chrome).
 */
export const loader = () =>
    json({
        title: profsConfig.meta.title,
        description: profsConfig.meta.description,
    });

export const meta = mergeMeta<typeof loader>(
    () => [],
    (props) => {
        const { data } = props;
        const title = createMetaTitle(props, [data?.title, 'ArchiPro']);
        const description = createMetaDescription([data?.description ?? '']);
        return [
            { title },
            { name: 'description', content: description },
            ...createOGTags({ meta: props, title, description }),
            {
                tagName: 'link',
                rel: 'canonical',
                href: `${B2B_CANONICAL_ORIGIN}/b2b/professionals`,
            },
        ];
    },
);

export default function B2BProfessionalsRoute() {
    return <B2BLandingPage config={profsConfig} />;
}
